import { Link } from "react-router-dom";
import { type ApprovalQueueRow, expiryCountdown } from "./approval-queue.js";

// Every value is rendered as React text (escaped); requesters control the action fields.
export function ApprovalQueueTable(
  { rows, base, nowMs }: { rows: ApprovalQueueRow[]; base: string; nowMs: number },
) {
  if (rows.length === 0) {
    return <p className="empty-state">No approvals waiting</p>;
  }
  return (
    <div className="table-wrap">
      <table className="stacked-table approval-queue-table" aria-label="Pending approvals">
        <thead>
          <tr>
            <th>Risk</th>
            <th>Goal</th>
            <th>Class</th>
            <th>Target</th>
            <th>Requester</th>
            <th>Expires</th>
            <th>Decision</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => {
            const context = row.action_context;
            const action = context?.execution.kind === "authorization_receipt"
              ? context.execution.agent_action
              : undefined;
            return (
              <tr key={row.approval_id} className="approval-queue-row">
                <td data-label="Risk">
                  {action?.risk === "high"
                    ? <span className="status danger"><i />HIGH RISK</span>
                    : context
                    ? <span className="status neutral"><i />Routine</span>
                    : <span className="status neutral"><i />{row.capability}</span>}
                  {!row.evidence && <small>Approval evidence unavailable; open the run</small>}
                </td>
                <td data-label="Goal">{context?.goal ?? "—"}</td>
                <td data-label="Class">{action?.action_class ?? context?.requested_autonomy ?? row.capability}</td>
                <td data-label="Target">{action?.target ?? context?.inputs[0]?.ref ?? "—"}</td>
                <td data-label="Requester">{row.requester}</td>
                <td data-label="Expires">
                  {row.evidence
                    ? <time dateTime={row.expires_at}>{expiryCountdown(row.expires_at, nowMs)}</time>
                    : "Unverified"}
                </td>
                <td className="stacked-action" data-label="Decision">
                  <Link className="strong-link" to={`${base}/runs/${encodeURIComponent(row.run_id)}`}>
                    Review and decide
                  </Link>
                  <small>{row.run_id}</small>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
